import { IMedicalCondition, IMedicalConditionCategory, IMedicalRecord, IMedicalRecordData,  IMedicalRecordParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const medicalRecordsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_medicalRecords: builder.query<ITableRes<IMedicalRecord>, IMedicalRecordParams>({
      query: (params) => ({
          url: `/student-medical-records/`,
          params: params
      }),
      providesTags: ['medical-records'],
    }),
    GET_medicalConditions: builder.query<ITableRes<IMedicalCondition>, any>({
      query: (params) => ({
          url: '/medical-conditions/',
          params: params
      }),
      providesTags: ['medical-conditions'],
      transformResponse: (response: ITableRes<IMedicalCondition>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
    }),
    GET_medicalConditionCategories: builder.query<ITableRes<IMedicalConditionCategory>, any>({
      query: (params) => ({
        url: '/medical-condition-categories/',
        params: params
      }),
      providesTags: ['medical-condition-categories'],
      transformResponse: (response: ITableRes<IMedicalConditionCategory>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
    }),
    GET_medicalRecordById: builder.query<IMedicalRecord, number>({
      query: (id) => ({
        url: `/student-medical-records/${id}/`,
      }),
      providesTags: ['medical-record'],
    }),
    POST_medicalRecord: builder.mutation<IMedicalRecord, IMedicalRecordData>({
      query: (body) => ({
        url: `/student-medical-records/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['medical-records'],
    }),
    PATCH_medicalRecord: builder.mutation<IMedicalRecord, { id: number; body: IMedicalRecordData }>({
      query: ({ id, body }) => ({
        url: `/student-medical-records/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['medical-record', 'medical-records'],
    }),
    DELETE_medicalRecord: builder.mutation<IMedicalRecord, number>({
      query: (id) => ({
        url: `/student-medical-records/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['medical-records'],
    }),
  }),
})

export const {
  useGET_medicalRecordsQuery,
  useGET_medicalConditionsQuery,
  useGET_medicalConditionCategoriesQuery,
  useGET_medicalRecordByIdQuery,
  usePOST_medicalRecordMutation,
  usePATCH_medicalRecordMutation,
  useDELETE_medicalRecordMutation,
} = medicalRecordsAPI
